module.exports = __webpack_public_path__ + "img/cynthia.77c29281.jpeg";